import { AlertBoxIcon } from './AlertBoxIcon';

/**
 * author: Austin Andrews
 * id 7B5D47A1-5658-4169-94C7-0C41E7179DD2
 * name alert-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-box.svg
 * tags
 * - Alert / Error 
 */
export const WarningBoxIcon = AlertBoxIcon;
export default WarningBoxIcon